import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { NotInterestedActionCompletedData, NotInterestedActionInputData, NotInterestedActionType } from './not-interested-action.model';
import { BrokerStatus } from '@partner/shared/SharedConstants';
import { NotInterestedActionFacade } from './not-interested-action.facade';
import { markAsNotInterestedSuccessMessage, reactivateSubmissionDialogData, reactivateSubmissionSuccessMessage } from './not-interested-action-data';
import { MatDialog } from '@angular/material/dialog';
import { NotInterestedDialogComponent } from '../not-interested-dialog/not-interested-dialog.component';
import { filter, switchMap, take, tap } from 'rxjs/operators';
import { CommonActionKey, SimpleDialogComponent, SimpleDialogData } from 'common';

@Component({
    selector: 'ifbp-not-interested-action',
    templateUrl: './not-interested-action.component.html',
    providers: [NotInterestedActionFacade],
    standalone: false
})
export class NotInterestedActionComponent implements OnChanges {
  isActionAvailable: boolean;
  readonly BrokerStatus = BrokerStatus;

  @Input()
  isMenuItem?: boolean;

  @Input()
  data: NotInterestedActionInputData;

  @Output()
  actionComplete = new EventEmitter<NotInterestedActionCompletedData>();

  constructor(
    private readonly facade: NotInterestedActionFacade,
    private readonly dialog: MatDialog) { }

  ngOnChanges(): void {
    this.isActionAvailable = this.facade.checkIfIsActionAvailable(this.data);
  }

  onClickMarkAsNotInterested() {
    this.facade.getNotInterestedDialogData().pipe(
      take(1),
      switchMap(data =>  NotInterestedDialogComponent.show(this.dialog, data)),
      filter(result => !!result),
      switchMap(result => this.facade.updateApplicationData(this.data.applicationId,
        this.facade.prepareSaveApplicationDataFromDialogResult(result),
        markAsNotInterestedSuccessMessage)),
      tap(updateResult =>
        this.emitActionComplete(updateResult as NotInterestedActionCompletedData, NotInterestedActionType.MarkAsNotInterested))
    ).subscribe();
  }

  onClickReactivate(): void {
    const dialogData: SimpleDialogData = reactivateSubmissionDialogData;
    SimpleDialogComponent.show(this.dialog, dialogData).subscribe((actionKey: string) => {
      if (actionKey === CommonActionKey.Confirm) {
        this.facade.updateApplicationData(this.data.applicationId, { stage: this.data.previousStage }, reactivateSubmissionSuccessMessage)
          .subscribe((data: NotInterestedActionCompletedData) => {
            this.emitActionComplete(data, NotInterestedActionType.Reactivate);
          })
      }
    });
  }

  private emitActionComplete(data: NotInterestedActionCompletedData, actionType: NotInterestedActionType) {
    this.actionComplete.emit({
      ...data,
      actionType
    });
  }
}
